import React, { Fragment, useState, useEffect, useRef } from "react";
import tools from "../../components/tools/tools";
// import TablaPro from "../../componentes/tabla";
import PhoneInput from "../../components/react-input-number";
import { useNavigate } from "react-router-dom";

import Select from '../../components/select'
// import 'react-intl-tel-input/dist/main.css';
import ItemCarnet from './item_carnet'
import ModalCarnetNuevo from './modal_nuevo_carnet'
import ImgServerr from "../../assets/img/server.gif";
import Loader from '../common/loader';

const Default = ({
    esEditar,
    esMesaRegistro,
}) => {
    let server = ''
    const [estatusConexion, setEstatusConexion] = useState(true)
    const [tipoRegistro, setTipoRegistro] = useState(0)
    const [modal, setModal] = useState({estado: 0, datos: {}})
    const [catalogos, setCatalogos] = useState({
        catTipoAsistente: [],
        catNacionalidad: []
    })
    const [selects, setSelects] = useState({
        listExpo: {},
        listTipoCarnet: {},
        listCNacion: {},
        listCTiposAsistente: {},
        listCEstado: {},
        listCCiudad: {},
        catCCiudad: [],
        listFEstado: {},
        listFCiudad: {},
        catFCiudad: [],
        listCPais: {},
        listFRegimenFiscal: {},
        listFUsoCfdi: {},
        listFMetodoPago: {},
        catTipoHospedaje: [],
        txtAplicaDF: false,
        selectedNumCarnets: 1,
        listMedios: {},
    })
    const [datosRegistro, setDatosRegistro] = useState(null)
    const [carnets, setCarnets] = useState([tools.getForm('formCarnet1', { active: 1})])
    const [formContacto, setFormContacto] = useState(tools.getForm('formContacto', { active: 1 }))
    const [formDf, setFormFf] = useState(tools.getForm('formDf', { active: 1 }))
    const [idRegistro, setIdRegistro] = useState(0)
    const [idDf, setIdDf] = useState(0)
    const [refresh, setRefresh] = useState(0)
    const [folioRc, setFolioRc] = useState('')
    const [estatusRegistrar, setEstatusRegistrar] = useState(false)
    const selectRef = useRef(null);

    const [datosEvento, setDatosEvento] = useState({
        numCarnetInd: 0,
        numCarnetDoble: 0,
        totalAsistentes: 0
    })

    const [isMesaExpositor, setIsMesaExpositor] = useState(false); 

    useEffect(() => {
        async function loadConfiguration() {
            if (window.eventos) {
                const response = await window.eventos.leerConfiguracion();
                if (response.estado === 'OK' && response.datos) {
                    const config = response.datos;
                    setIsMesaExpositor(config.isMesaExpositor || false);
                }
            }
        }
        loadConfiguration();
    }, []);

    useEffect(() => {
        console.log(123, isMesaExpositor)
    }, [isMesaExpositor]);

    //^^ INICIO ENVIO

    const onClickEnviar = () => {
        let btn = document.getElementById('btnEnviar')
        btn.disabled = true
        let contactoIgnore = ['txtCTel', 'txtCWhatssApp', 'listCTiposAsistente', 'txtCEmpresa', 'txtCEstacion', 'txtCPermiso', 'listCNacion', 'listMedios'],
            carnetsIgnore = ['txtEsAnfitrion', 'txtWhatsappSeg']
            setEstatusRegistrar(true)
        // if(selects.listTipoCarnet.clave == 4 ||
        //    selects.listTipoCarnet.clave == 5 ||
        //    selects.listTipoCarnet.clave == 6){
            contactoIgnore = [...contactoIgnore, 'txtCTelCode', 'txtCTelPais', 'txtCWhatssAppCode', 'txtCWhatssAppPais', 'txtCEmpresa', 'listCEstado', 'listCCiudad', 'txtCCorreo', 'txtCNombre', 'txtCApellidos', 'listCPais', 'txtCEstado', 'txtCCiudad']

            if( selects.listTipoCarnet.clave == 3 ){
                carnetsIgnore = [...carnetsIgnore, 'listGenero', 'txtWhatsapp', 'txtCorreo', 'listGeneroSeg', 'txtWhatsappSeg', 'txtCorreoSeg', 'txtApellidos', 'txtNombre', 'txtPuesto', 'txtWhatsapp', 'txtWhatsappISO', 'txtWhatsappCodPais', 'txtEmpresa']
            } else {
                carnetsIgnore = [...carnetsIgnore, 'listGenero', 'txtWhatsapp', 'txtCorreo', 'listGeneroSeg', 'txtWhatsappSeg', 'txtCorreoSeg', 'txtPuesto', 'txtWhatsapp', 'txtWhatsappISO', 'txtWhatsappCodPais']
            }
            // 'txtFechaInicio', 'txtFechaFin'
        // }

        const _formContacto = tools.getForm('formContacto', {claveEtiquetas: '.txtVacios', ignore: contactoIgnore})
        console.log(111, _formContacto)

        const _formFormDf = tools.getForm('formDf', {claveEtiquetas: '.txtVaciosDf', ignore: ['txtFComentarios', 'txtFNumInt']})
        console.log(222, _formFormDf)

        const _carnets = carnets.map((s, i) => tools.getForm(`formCarnet${i + 1}`, {claveEtiquetas: `.txtVaciosItem${i + 1}`, ignore: carnetsIgnore}))
        console.log(333, _carnets)

        const formCarnets = carnets.map((s, i) => {
            return tools.getForm(`formCarnet${i + 1}`, {claveEtiquetas: `.txtVaciosItem${i + 1}`, ignore: carnetsIgnore.map((t) => t+(i + 1))})
        }).map((v) => v.data)
        console.log(444, formCarnets)
        // .map((v) => v.data)

        let arrIsEmtyCarnets = 0
        let correoNoValido = 0
        let correosRepetidos = 0

        _carnets.map((s) => {
            if(s.isEmtyCount){
                arrIsEmtyCarnets += 1
            }
        })

        if(selects.listTipoCarnet.clave === null || selects.listTipoCarnet.clave === undefined){
            setEstatusRegistrar(false)
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Hay que seleccionar tipo de carnet para continuar con el registro`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        }

        // if(selects.listTipoCarnet.clave === 3 && (selects.listExpo.clave === null || selects.listExpo.clave === undefined)){
        //     return tools.notie.alert({
        //         type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
        //         text: `Para el caso de carnet tipo Expositor hay que seleccionar el Expositor correspondiente`,
        //         time: 3, // optional, default = 3, minimum = 1,
        //         position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
        //    
        
        // if(selects.listTipoCarnet.clave == 1 || selects.listTipoCarnet.clave == 2 || selects.listTipoCarnet.clave == 8){
            if(!_formContacto.data.txtCComentarios){
                setEstatusRegistrar(false)
                btn.disabled = false
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Favor de llenar en el campo de comentarios de contacto, <strong>¿Motivo (descripción breve)?</strong> y por <strong>¿Quien fue autorizado?</strong> este tipo de carnet.`,
                    time: 4, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                  })
            }
        // }

        console.log(555, _formContacto)

        if(_formContacto.isEmtyCount){
            setEstatusRegistrar(false)
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Los datos de contacto no pueden estar vacíos`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
              })
        }

        // if(_formFormDf.isEmtyCount && 
        //     (selects.listTipoCarnet.clave === 1 ||
        //     selects.listTipoCarnet.clave === 8 ||
        //     selects.listTipoCarnet.clave === 2)
        // ){
        if(_formFormDf.isEmtyCount && selects.txtAplicaDF)
        {
            setEstatusRegistrar(false)
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Los datos fiscales no pueden estar vacíos`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
              })
        }

        if(arrIsEmtyCarnets){
            setEstatusRegistrar(false)
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Los datos de los carnets no pueden estar vacíos`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
              })
        }

        // CURP y RFC solo obligatorios para Asistente - General (1-87) y Asistente - Premium (1-89)
        let faltantesCarnet = [];
        const esGeneralOPremium = (selects?.listTipoCarnet && (selects.listTipoCarnet.clave === '1-87' || selects.listTipoCarnet.clave === '1-89')) ||
            (esEditar && (String(datosRegistro?.convencion?.tipo_carnet) === '1-87' || String(datosRegistro?.convencion?.tipo_carnet) === '1-89'));
        formCarnets.forEach((c, idx) => {
            const faltan = [];
            if (esGeneralOPremium) {
                if(!c.txtCurp || c.txtCurp.trim() === '') faltan.push('CURP');
                if(!c.txtRfc || c.txtRfc.trim() === '') faltan.push('RFC');
                if(!c.listOcupacion || c.listOcupacion.trim() === '') faltan.push('Ocupación');
            }
            if(faltan.length){
                faltantesCarnet.push(`Carnet ${idx + 1} (${faltan.join(', ')})`);
            }
        });

        if(faltantesCarnet.length){
            setEstatusRegistrar(false)
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning',
                text: `Faltan datos obligatorios en los carnets: ${faltantesCarnet.join('; ')}`,
                time: 5,
                position: 'top'
            })
        }

        // if(selects.listTipoCarnet.clave == 3){
        //     formCarnets.map((v) => {
        //         if(v.txtEsAnfitrion){
        //             correoNoValido += tools.validaCorreo(v.txtCorreo)? 0: 1
        //         }
        //     })

        //     if(correoNoValido > 0){
        //         return tools.notie.alert({
        //             type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
        //             text: `Para poder registrar expositores de tipo anfitrión es necesario un correo valido ejemplo (usuario@empresa.mx)`,
        //             time: 4, // optional, default = 3, minimum = 1,
        //             position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
        //           })
        //     }
        // }

        formCarnets.map((v, i) => {
            if(formCarnets.find((s, k) => s.txtCorreo == v.txtCorreo && i !== k)){
                correosRepetidos += 1
            }
        })

        // if(correosRepetidos){
        //     return tools.notie.alert({
        //         type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
        //         text: `Existe algun carnet con el mismo correo, favor de revisar y corregir los datos.`,
        //         time: 4, // optional, default = 3, minimum = 1,
        //         position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
        //       })
        // }

        

        _formContacto.data.txtCWhatssApp = formContacto.data.txtCWhatssApp
        _formContacto.data.txtCWhatssAppCode = formContacto.data.txtCWhatssAppCode
        _formContacto.data.txtCWhatssAppPais = formContacto.data.txtCWhatssAppPais
        _formContacto.data.txtCTel = formContacto.data.txtCTel
        _formContacto.data.txtCTelCode = formContacto.data.txtCTelCode
        _formContacto.data.txtCTelPais = formContacto.data.txtCTelPais

        _formFormDf.data.txtFWhatsapp = formDf.data.txtFWhatsapp
        _formFormDf.data.txtFWhatsappCode = formDf.data.txtFWhatsappCode
        _formFormDf.data.txtFWhatsappPais = formDf.data.txtFWhatsappPais

        // formCarnets.txtWhatsapp =           datosRegistro.asistentes.txtWhatsapp
        // formCarnets.txtWhatsappCodPais = carnets.map((carnet, i) => {
        //     carnet.txtWhatsappCodPais
        // })
        // formCarnets.txtWhatsappISO =        formCarnets.txtWhatsappISO

        console.log(555, estatusConexion)
        console.log(666, tipoRegistro)
        console.log(777, modal)
        console.log(888, catalogos)
        console.log(999, selects)
        console.log(100, datosEvento)
        console.log(200, selectRef)
        console.log(300, estatusRegistrar)
        console.log(400, folioRc)
        console.log(500, refresh)
        console.log(600, idDf)
        console.log(700, idRegistro)
        console.log(800, formDf)
        console.log(900, formContacto)
        console.log(1000, carnets)
        console.log(1100, datosRegistro)

        formCarnets.map((carnets, i) => {
            console.log(1200, carnets)
        })

        fetch('/rt_mesaregistro_registro', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idPsp: datosEvento.ID_PSP,
                listTipoCarnet: selects.listTipoCarnet.clave,
                listExpo: selects.listExpo.clave? selects.listExpo.clave: 0,
                txtEsCortesia: selects.txtEsCortesia,
                //txtAplicaDF: selects.txtAplicaDF,
                formContacto: _formContacto.data,
                formFormDf: _formFormDf.data,
                formCarnets
            })
        })
        .then((response) => response.json())
        .then((response) => {
            console.log(1300, response)
            setEstatusRegistrar(false)

            if(!response.estado){
                btn.disabled = false
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Detalle en el servidor, favor de contactar a soporte técnico`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            if(response.estado && response.existe){
                let text = ''

                response.correos.map((v) => {
                    text += v.CORREO + ', '
                })

                text = text.substring(0, text.length - 2)
                btn.disabled = false
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Hay usuarios que ya existen, favor de revisar sus datos (${text})`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            if(response.excedio){
                btn.disabled = false
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Excedio el número maximo de gafets o anfitriones del expositor, pasar con <strong>Ricardo</strong> de <strong>Onexpo</strong> para aumentar registros`,
                    time: 5, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            btn.disabled = true
            setTimeout(() => {window.location.href = '/mesaregistro'}, 2000)
            tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Registro realizado exitosamente`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
            btn.disabled = true
        })
        .catch((err) => {
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Detalle en el servidor, favor de contactar a soporte técnico`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    //^^ FIN ENVIO

    const onClickEditarContacto = () => {
        let contactoIgnore = ['txtCTel', 'txtCWhatssApp', 'listCTiposAsistente', 'txtCEmpresa', 'txtCEstacion', 'txtCComentarios', 'listCNacion', 'txtCTelCode', 'txtCTelPais', 'txtCWhatssAppCode', 'txtCWhatssAppPais', 'txtCEmpresa', 'listCEstado', 'listCCiudad', 'txtCCorreo', 'txtCNombre', 'txtCApellidos', 'listCPais', 'txtCEstado', 'txtCCiudad']
        let carnetsIgnore = ['txtEsAnfitrion', 'listGenero', 'txtWhatsapp', 'txtCorreo', 'listGeneroSeg', 'txtWhatsappSeg', 'txtCorreoSeg']

        const _formContacto = (tools.getForm('formContacto', {claveEtiquetas: '.txtVacios', ignore: contactoIgnore})).data
        const _carnets = datosRegistro?.carnets.map((s, i) => (tools.getForm(`formCarnet${i + 1}`, {claveEtiquetas: `.txtVaciosItem${i + 1}`, ignore: carnetsIgnore})).data)

        _formContacto.txtCWhatssApp = formContacto.data.txtCWhatssApp
        _formContacto.txtCWhatssAppCode = formContacto.data.txtCWhatssAppCode
        _formContacto.txtCWhatssAppPais = formContacto.data.txtCWhatssAppPais
        _formContacto.txtCTel = formContacto.data.txtCTel
        _formContacto.txtCTelCode = formContacto.data.txtCTelCode
        _formContacto.txtCTelPais = formContacto.data.txtCTelPais

        console.log(123, _formContacto);
        console.log(321, _carnets);
        
        if(_formContacto.isEmtyCount){
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Los datos de contacto no pueden estar vacíos`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
              })
        }

        fetch('/rt_mesaregistro_contacto', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                listTipoCarnet: datosRegistro?.convencion.TIPO_CARNET,
                listExpo: 0,
                formContacto: _formContacto,
                formCarnets: _carnets
            })
        })
        .then((response) => response.json())
        .then((response) => {
            if(!response.estado){
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Detalle en el servidor, vuelva a intenter`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            setTimeout(() => window.location.reload('.'), 2000)
            // setTimeout(() => history.push(`/registros/3/${1}`), 2000)

            tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Datos de contacto editados correctamente`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
        .catch((err) => {
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Detalle en el servidor, vuelva a intenter`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    const onClickEditarFactura = () => {
        const _formFormDf = tools.getForm('formDf', {claveEtiquetas: '.txtVaciosDf', ignore: ['txtFComentarios', 'txtFNumInt']})

        if(_formFormDf.isEmtyCount && 
            (selects.listTipoCarnet.clave === 1 ||
            selects.listTipoCarnet.clave === 8 ||
            selects.listTipoCarnet.clave === 2)
        ){
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Los datos fiscales no pueden estar vacíos`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
              })
        }

        _formFormDf.data.txtFWhatsapp = formDf.data.txtFWhatsapp
        _formFormDf.data.txtFWhatsappCode = formDf.data.txtFWhatsappCode
        _formFormDf.data.txtFWhatsappPais = formDf.data.txtFWhatsappPais

        fetch('/rt_mesaregistro_factura', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idRc: idRegistro,
                txtAplicaDF: selects.txtAplicaDF,
                formFormDf: _formFormDf.data
            })
        })
        .then((response) => response.json())
        .then((response) => {
            if(!response.estado){
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Detalle en el servidor, vuelva a intenter`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            setTimeout(() => window.location.reload('.'), 2000)
            // setTimeout(() => history.push(`/registros/3/${1}`), 2000)

            tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Datos de facturación editados correctamente`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
        .catch((err) => {
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Detalle en el servidor, vuelva a intenter`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    const onSelectEstado = (item, list, charge) => {
        console.log('estado')
        tools.useFetch({
            ruta: 'rt_catalogos_select_ciudad',
            method: 'POST',
            body: item
        }, (response) => {
            if (list === 1) {
                setSelects((s) => ({
                    ...s,
                    listCEstado: item,
                    catCCiudad: response.datos,
                }))
                if(esEditar){
                    if(charge == 2){
                        setCatalogos((s) => ({
                            ...s,
                            catCiudad: response.datos,
                        }))
                    }
                    for (let i = 0; i < document.getElementById('listCCiudad').options.length; i++) {
                        if (document.getElementById('listCCiudad').options[i].value === datosRegistro?.convencion.CIUDAD) {
                            document.getElementById('listCCiudad').selectedIndex = i;
                            console.log('seleccionado');
                        }
                    }
                }
            }

            if (list === 2) {
                setSelects((s) => ({
                    ...s,
                    listFEstado: item,
                    catFCiudad: response.datos,
                }))
            }
        })
    }

    const onClickNuevoCarnet = (num = 1, tipo = 1) => {
        console.log('nuevo carnet', num, tipo);
        
        let arrNuevos = []

        if(typeof num == 'number'){
            if(num > 100){
                return
            }

            if(num < 1){
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `El número de carnets debe de ser mayor a 0`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            if(tipo == 2){
                return setCarnets((s) => {
                    return ([
                        ...s,
                        tools.getForm(`formCarnet${carnets.length}`, { active: 1 })
                    ])
                })
            }

            console.log('carnets', carnets.length);
            console.log('num', num);

            if(num > carnets.length){
                for(let i = 0; i < num - carnets.length; i++){
                    arrNuevos.push(tools.getForm(`formCarnet${carnets.length}`, { active: 1 }))
                }
                
                setCarnets((s) => {
                    return ([
                        ...s,
                        ...arrNuevos
                    ])
                })
            }else{
                setCarnets(carnets.filter((v, i) => i < num ))
            }
        }
    }

    const onClickEliminarCarnet = (indice, row) => {
        if (carnets.length === 1) {
            return
        }

        // carnet
        if(!esEditar){
            let arr = ((carnets.map((s, i) => tools.getForm(`formCarnet${i + 1}`, {claveEtiquetas: `.txtVaciosItem${i + 1}`, ignore: ['txtEsAnfitrion']}))).filter((v, i) => i !== indice))
            setCarnets(arr)
            setSelects((v) => ({
                ...v,
                selectedNumCarnets: arr.length
            }))
            return
        }

        let item = carnets.map((s, i) => tools.getForm(`formCarnet${i + 1}`, {claveEtiquetas: `.txtVaciosItem${i + 1}`, ignore: ['txtEsAnfitrion']})).filter((v, i) => i === indice)
        item = item[0].data

        tools.notie.confirm({
            text: `Se eliminara el carnet de <strong>${item.txtNombre} ${item.txtApellidos}</strong> ¿Esta de acuerdo?`,
            submitText: 'Si, eliminar', // optional, default = 'Yes'
            cancelText: 'No, cancelar', // optional, default = 'Cancel'
            position: 'top', // optional, default = 'top', enum: ['top', 'bottom']
            submitCallback: () => {
                fetch('/rt_mesaregistro_eliminar_carnet', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({
                        idRc: idRegistro,
                        idSub: row.idSub
                    })
                })
                .then((response) => response.json())
                .then((response) => {
                    setRefresh((s) => !s)
                    tools.notie.alert({
                        type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                        text: `Registro eliminado correctamente`,
                        time: 2, // optional, default = 3, minimum = 1,
                        position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                    })
                })
                .catch((err) => {
                    return tools.notie.alert({
                        type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                        text: `Detalle en el servidor, vuelva a intentar`,
                        time: 3, // optional, default = 3, minimum = 1,
                        position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                    })
                })
            }, // optional
            cancelCallback: () => {
            }// optional
        })
    }

    const onClickEditarCarnet = (indice, row) => {
        let vacios = ''
        let item = carnets.map((s, i) => {
            let form = tools.getForm(`formCarnet${i + 1}`, {claveEtiquetas: `.txtVaciosItem${i + 1}`, ignore: ['txtEsAnfitrion',`txtCorreo${i + 1}`,`listGenero${i + 1}`,`txtWhatsapp${i + 1}`, `txtCorreo${i + 1}`,`listGeneroSeg${i + 1}`,`txtWhatsappSeg${i + 1}`, `txtCurp${i + 1}`, `txtRfc${i + 1}`, `listOcupacion${i + 1}`]})
            if(form.isEmtyCount){
                vacios = form.isEmtyString
            }
            return form
        }).filter((v, i) => i === indice)
        item = item[0].data

        if(vacios.length){
            return  tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Faltan los siguientes campos (${vacios})`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        }

        console.log(111, item)

        item.txtWhatsapp = item.txtWhatsapp1.replace(/\s/g, '').slice(-10);
        
        console.log(222, item)

        fetch('/rt_mesaregistro_editar_carnet', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idRc: idRegistro,
                idSub: row.idSub,
                id1: row.id,
                id2: row.id2,
                listTipoCarnet: selects.listTipoCarnet.clave,
                formCarnets: [item]
            })
        })
        .then((response) => response.json())
        .then((response) => {
            setRefresh((s) => !s)
            tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Registro editado correctamente`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
        .catch((err) => {
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Detalle en el servidor, vuelva a intentar`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    function editarDatosContacto(){
        let btnEditar = document.getElementById('btnEditar')
        btnEditar.disabled = true
        let form = tools.getForm('formContacto', {ignore: [], claveEtiquetas: 'txtVacios'})
        let data = form.data

        console.log(5555555555555, data)

        if(data.txtCComentarios == ""){
            btnEditar.disabled = false
            return tools.notie.alert({
                type: 'warning',
                text: 'Es necesario llenar todos los comentario de contacto para continuar.',
                time: 4
            })
        }

        //id de param
        let id = tools.getParamsId(window.location.pathname)
        console.log(89,id)
        data.idRc = id

        // data.listCTiposAsistente = document.getElementById('listCTiposAsistente').value
        data.listCEstado = document.getElementById('listCEstado').value
        data.listCCiudad = document.getElementById('listCCiudad').value
        data.listMedios = document.getElementById('listMedios').value


        fetch('/rt_mesaregistro_editar_contacto', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(response => response.json())
        .then((response) => {
            console.log(response)

            if (!response.estado) {
                btnEditar.disabled = false
                return tools.notie.alert({
                    type: 'warning',
                    text: 'Detalle en el servidor, vuelva a intentar.',
                    time: 4
                })
            }

            tools.notie.alert({
                type: 'success',
                text: 'Datos de contacto editados correctamente.',
                time: 4
            })

            btnEditar.disabled = false
        })
        .catch((err) => {
            console.log(err)
            btnEditar.disabled = false
            return
        })
    }

    useEffect(() => {
        let isS = true;
        let id = 0

        if(esEditar){
            id = tools.getParamsId(window.location.pathname)
            console.log('🔍 Estableciendo idRegistro:', id, 'para esEditar:', esEditar);
            setIdRegistro(id)
        }

        fetch('/rt_catalogos_mesa', {
            method: 'POST',
            body: JSON.stringify({
                esEditar, id, esMesaRegistro
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((response) => response.json())
        .then((response) => {
            if(!isS){
                return 
            }

            if(tipoRegistro == 2){
                response.datos.catTipoCarnets = response.datos.catTipoCarnets.filter((v) => v.clave == 3)
            }

            setDatosEvento((s) => ({...s, ...response.datosEvento}))
            setCatalogos((s) => ({
                ...s,
                ...response.datos
            }))

            if(esEditar){

                setDatosRegistro(response.detalleCarnet)

                setFormContacto((s) => ({
                    ...s,
                    data: {
                        ...s.data,
                        txtCWhatssApp: response.detalleRegistro?.contacto.WHATSAPP,
                        txtCWhatssAppCode: response.detalleRegistro?.contacto.WHATSAPP_COD,
                        txtCWhatssAppPais: response.detalleRegistro?.contacto.WHATSAPP_ISO,
                        txtCTel: response.detalleRegistro?.contacto.TELEFONO,
                        txtCTelCode: response.detalleRegistro?.contacto.TELEFONO_COD,
                        txtCTelPais: response.detalleRegistro?.contacto.TELEFONO_ISO,
                    },
                }));

                let detalleContacto = response.detalleCarnet.convencion
                let detalleAsistentes = response.detalleCarnet.asistentes
                let datosFiscales = response.detalleCarnet.df

                // Select de contacto
                let selectedNumCarnets = response.detalleCarnet.selectedNumCarnets
                let selectCarnet = {label: 0, clave:  0}
                let selectNacion = {label: detalleContacto.nacionalidad_desc, clave:  detalleContacto.listCNacion? '1': '0'}
                let selectEdo = {label: detalleContacto.listCEstadoDesc, clave:  detalleContacto.listCEstado}
                let selectCd = {label: detalleContacto.listCCiudadDesc, clave:  Number(detalleContacto.listCCiudad)}

                //Select de datos fiscales
                let selectEdoDf = {label: datosFiscales.listFEstadoDesc, clave: datosFiscales.listFEstado}
                let selectCdDf = {label: datosFiscales.listFCiudadDesc, clave: datosFiscales.listFCiudad}
                let selectRf = {label: datosFiscales.listFRegimenFiscalDesc, clave:  datosFiscales.listFRegimenFiscal}
                let selectUsoCfdi = {label: datosFiscales.listFUsoCfdiDesc, clave: datosFiscales.listFUsoCfdi}
                let selectFormaPago = {label: datosFiscales.listFFormaPagoDesc, clave: datosFiscales.listFFormaPago}

                setCarnets(detalleAsistentes.map((v) => ({...tools.getForm('formCarnet1', { active: 1}), data: v})))
                
                setSelects((s) => ({ ...s, 
                    selectedNumCarnets: selectedNumCarnets,
                    listTipoCarnet: selectCarnet, 
                    listCNacion: selectNacion,
                    listCCiudad: selectCd,
                    catCCiudad: response.datos.catCiudad,
                    listCEstado: selectEdo,
                    txtAplicaDF: datosFiscales.txtFCorreo != '' ? true : false,
                    // txtAplicaDF: datosFiscales.idDf,
                    // txtAplicaDF: selectCarnet.clave == 1 || selectCarnet.clave == 2 || selectCarnet.clave == 8,
                    // txtEsCortesia: selectCarnet.clave == 1 || selectCarnet.clave == 2? false: selectCarnet.clave == 8,
                    listFEstado: selectEdoDf,
                    listFCiudad: selectCdDf,
                    catFCiudad: response.datos.catFCiudad,
                    listFRegimenFiscal: selectRf,
                    listFUsoCfdi: selectUsoCfdi,
                    listFMetodoPago: selectFormaPago,
                    txtEsCortesia: detalleContacto.txtEsCortesia,
                }))

                setFormContacto((v) => ({
                    ...v,
                    data: detalleContacto
                }))

                setIdDf(datosFiscales.idDf)

                setFormFf((v) => ({
                    ...v,
                    data: datosFiscales
                }))
                
                setFolioRc(detalleContacto.folio)
            }
        })

        return () => (isS = false);
    }, [refresh, tipoRegistro]);

    useEffect(() => {
        let isS = true;
        if (window.eventos) {
            window.eventos.tipoRegistro()
                .then((response) => {
                    if (isS) {
                        setTipoRegistro(response)
                    }
                })
                .catch(() => {
                    if (isS) {
                        setTipoRegistro(1)
                    }
                })
        }
        return () => (isS = false);
    }, [])

    useEffect(() => {
        console.log(1233333, datosRegistro);
        console.log(1233334, selects);
        console.log(321, catalogos);
        if (datosRegistro != null) {
            console.log('entra');

            // If we are in edit mode, try to normalize ocupación values that arrive as free-text
            // like "07.8 - Servicio postal y mensajería" into listTipoOcupacion and listOcupacion
            try {
                if (esEditar && !datosRegistro._ocupacionParsed) {
                    const parseOcup = (entry) => {
                        if (!entry) return entry
                        const copy = { ...entry }
                        // If listOcupacion already exists and looks like a clave, skip
                        if (!copy.listOcupacion || String(copy.listOcupacion).trim() === '') {
                            const posible = copy.listOcupacion || copy.PUESTO_DP || copy.txtPuesto || copy.PUESTO || ''
                            const m = String(posible || '').match(/^(\d+\.\d+)\s*-\s*(.+)$/)
                            if (m) {
                                const clave = m[1]
                                const tipo = String(clave).split('.')[0]
                                copy.listOcupacion = clave
                                copy.listTipoOcupacion = tipo
                            }
                        } else {
                            // If listOcupacion contains a combined label like "07.8 - ...", extract clave
                            const m2 = String(copy.listOcupacion).match(/^(\d+\.\d+)\s*-\s*(.+)$/)
                            if (m2) {
                                const clave = m2[1]
                                copy.listOcupacion = clave
                                copy.listTipoOcupacion = String(clave).split('.')[0]
                            }
                        }
                        return copy
                    }

                    const asistentesParsed = datosRegistro.asistentes ? datosRegistro.asistentes.map(parseOcup) : datosRegistro.asistentes
                    const carnetsParsed = datosRegistro.carnets ? datosRegistro.carnets.map(parseOcup) : datosRegistro.carnets

                    const newDatos = { ...datosRegistro, asistentes: asistentesParsed, carnets: carnetsParsed, _ocupacionParsed: true }
                    setDatosRegistro(newDatos)
                    // update local selects/catalogs rendering by yielding control briefly
                    setTimeout(() => {
                        changeEstado()
                    }, 500);
                    return
                }
            } catch (err) {
                console.error('Error parseando ocupaciones en datosRegistro', err)
            }

            // If not in edit mode or already parsed, just call changeEstado as before
            setTimeout(() => {
                changeEstado()
            }, 500);
        }
    }, [datosRegistro]);
    
    const changeEstado = async () => {
        let clave = datosRegistro?.convencion.ESTADO;
        let label = document.getElementById('listCEstado').options[document.getElementById('listCEstado').options.selectedIndex].text
        onSelectEstado({clave: clave, label: label}, 1)
    }

    useEffect(() => {
        console.log(4573245, selects)
        console.log(4573245, catalogos)
    }, [selects]);

    // Evaluar de forma consistente si el registro padre es Asistente - Estudiante.
    // Consideramos varios formatos: selects.listTipoCarnet.clave === '1-88', o en modo edición
    // cuando datosRegistro.convencion.tipo_carnet === 1 y idPsp === 88, o cuando el texto contiene 'estudiante'.
    const parentIsStudentGlobal = (selects?.listTipoCarnet && selects.listTipoCarnet.clave === '1-88')
        || (esEditar && (
            String(datosRegistro?.convencion?.tipo_carnet) === '1-88'
            || (Number(datosRegistro?.convencion?.tipo_carnet) === 1 && Number(datosRegistro?.convencion?.idPsp) === 88)
            || String(datosRegistro?.convencion?.TIPO_CARNET_TEXT || '').toLowerCase().includes('estudiante')
        ))

    return (
        <div>
            <Fragment>
            {esEditar?<Loader status={datosRegistro}/>:''}
                <div className="col-sm-12 mt-5 registros-nuevos">
                    <div className="card mt-5">
                        <div className="card-header p-0 mt-3">
                            <div className='row p-0 m-0 d-flex justify-content-center'>                                
                                <div className="col-sm-10 p-0 m-0 d-flex justify-content-center">
                                    {esMesaRegistro?<button type="button" 
                                        style={{position: 'absolute', left: 0}}
                                        className="btn btn-primary " 
                                        onClick={() => {
                                            // window.history.back()
                                            window.location.href = '/mesaregistro'
                                        }}
                                    >
                                        <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                    </button>: ''}
                                    <h4 className="">{!esEditar? 'Nuevo Registro': `Editar Registro ${folioRc?`#${folioRc}`:``}`}</h4>
                                </div>
                            </div>
                        </div>
                        <div className="datatable-react mt-4 d-flex justify-content-center">
                            <div className="col-sm-10 mt-0">
                                <div className="row mb-4 carnet-select">
                                    <div className="col-md-6">
                                        <label style={{ fontWeight: 600 }}>Tipo de registro <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            disabled={esEditar}
                                            className="form-control form-control-md border border-dark"
                                            data-label="Tipo Carnet"
                                            placeholder='Seleccionar tipo carnet'
                                            id="listTipoCarnet"
                                            name="listTipoCarnet"
                                            value={datosRegistro?.convencion.tipo_carnet == 1 ? datosRegistro?.convencion.tipo_carnet + '-' + datosRegistro?.convencion.idPsp : datosRegistro?.convencion.tipo_carnet}
                                            datos={
                                                [
                                                        { value: '1-1001-1002', label: 'Conferencia', clave: '1-1001-1002' },
                                                        { value: '1-1001-1003', label: 'Acceso Networking', clave: '1-1001-1003' },
                                                        { value: '1-1001-1004', label: 'Conferencia + Acceso Networking', clave: '1-1001-1004' },
                                                        { value: '1-1001-1005', label: '1er taller + Acceso Networking', clave: '1-1001-1005' },
                                                        { value: '1-1001-1006', label: '2do taller + Acceso Networking', clave: '1-1001-1006' },
                                                        { value: '6', label: 'Staff', clave: '6' },
                                                        { value: '19', label: 'Proveedor', clave: '19' },
                                                        // { value: '4', label: 'Invitado Especial', clave: '4' }, // Invitado
                                                        // { value: '11', label: 'Ponente', clave: '11' }, // speaker en bd
                                                    ]

                                                // isMesaExpositor
                                                    // ? [
                                                    //     { value: '3', label: 'Socio', clave: '3' }
                                                    // ] // Show only "Expositor" if isMesaExpositor is true
                                                    // : [
                                                    //     { value: '1', label: 'Asistente', clave: '1' },
                                                    //     { value: '6', label: 'Staff', clave: '6' },   
                                                    //     { value: '4', label: 'Invitado Especial', clave: '4' }, // Invitado
                                                    //     { value: '3', label: 'Expositor', clave: '3' }, // expositor
                                                    //     // { value: '4', label: 'VIP', clave: '4' },
                                                    //     // { value: '5', label: 'Asistente', clave: '5' }      
                                                    //     { value: '11', label: 'Ponente', clave: '11' }, // speaker en bd
                                                    //     //{ value: '19', label: 'Socio', clave: '19' } 
                                                    // ]

                                                    


                                                    
                                            }
                                            onChange={({ item }) => {
                                                setSelects((s) => ({ 
                                                    ...s, 
                                                    listTipoCarnet: item, 
                                                    // txtAplicaDF: item.clave == 1 || item.clave == 2 || item.clave == 8,
                                                    // txtEsCortesia: item.clave == 1 || item.clave == 2? false: item.clave == 8
                                                }))
                                            }}
                                        />
                                    </div>
                                    {/* {selects.listTipoCarnet.clave === 3 ? <div className="col-md-6">
                                        <label
                                            style={{ fontWeight: 600 }}
                                            htmlFor="papellidos"
                                        >
                                            Expositor <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="form-control form-control-md border border-dark"
                                            data-label="Tipo Carnet"
                                            placeholder='Seleccionar expositor'
                                            id="listExpo"
                                            name="listExpo"
                                            value={selects.listExpo.clave}
                                            datos={catalogos.catExpo}
                                            onChange={({ item }) => {
                                                setSelects((s) => ({ ...s, listExpo: item }))
                                            }}
                                        />
                                    </div> : ''} */}
                                </div>
                                <div>
                                {/* {!(selects.listTipoCarnet.clave == 3)? */}
                                <form id="formContacto" className="row form theme-form" >
                                    <div className="col-12 contacto-title">
                                        <h5 className="mb-3 text-info">Datos Contacto</h5>
                                    </div>
                                    {esEditar ? 
                                    <div className="col-md-6" hidden>
                                        <div className="form-group">
                                            <input className="form-control border border-dark"
                                                id="txtFolio"
                                                name="txtFolio" type="text"  
                                                defaultValue={datosRegistro?.convencion.folio}
                                            />
                                        </div>
                                    </div> : ''}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pnombre"
                                            >
                                                Nombre(s)
                                            </label>
                                            <input className="form-control border border-dark"
                                                id="txtCNombre"
                                                name="txtCNombre" type="text" placeholder="Nombre(s)" 
                                                defaultValue={datosRegistro?.convencion.txtCNombre}
                                                onInput={(e) => {tools.limitChar(e, 3, 80)}}
                                                />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="papellidos"
                                            >
                                                Apellidos
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                id="txtCApellidos"
                                                name="txtCApellidos"
                                                type="text"
                                                placeholder="Apellidos"
                                                defaultValue={datosRegistro?.convencion.txtCApellidos}
                                                onInput={(e) => {tools.limitChar(e, 3, 80)}}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pcorreo"
                                            >
                                                Correo Electrónico
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                id="txtCCorreo"
                                                name="txtCCorreo"
                                                type="text"
                                                placeholder="Correo Electrónico"
                                                defaultValue={datosRegistro?.convencion.txtCCorreo}
                                                onInput={(e) => {tools.limitChar(e, 2, 80)}}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pwhatsapp"
                                            >
                                                Whatsapp
                                            </label>
                                            <br></br>
                                            <PhoneInput
                                                id='txtCWhatssApp'
                                                name='txtCWhatssApp'
                                                className={'border border-dark'}
                                                value={datosRegistro?.convencion.txtCWhatssApp || formContacto?.data.txtCWhatssApp}
                                                code={datosRegistro?.convencion.txtCWhatssAppCode || formContacto?.data.txtCWhatssAppCode}
                                                iso={datosRegistro?.convencion.txtCWhatssAppPais || formContacto?.data.txtCWhatssAppPais}
                                                label='Whatsapp'
                                                onChange={(datos) => {
                                                    setFormContacto((s) => ({
                                                        ...s,
                                                        data: {
                                                            ...s.data,
                                                            txtCWhatssApp: datos.number,
                                                            txtCWhatssAppCode: datos.code,
                                                            txtCWhatssAppPais: datos.iso,
                                                        },
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="ptelefono"
                                            >
                                                Teléfono
                                            </label>
                                            <br></br>
                                            <PhoneInput
                                                id='txtCTel'
                                                name='txtCTel'
                                                className={'border border-dark'}
                                                value={datosRegistro?.convencion.txtCTel || formContacto?.data.txtCTel}
                                                code={datosRegistro?.convencion.txtCTelCode || formContacto?.data.txtCTelCode}
                                                iso={datosRegistro?.convencion.txtCTelPais || formContacto?.data.txtCTelCode}
                                                label='Teléfono'
                                                onChange={(datos) => {
                                                    // console.log('PhoneInput onChange called with:', datos);

                                                    setFormContacto((s) => ({
                                                        ...s,
                                                        data: {
                                                            ...s.data,
                                                            txtCTel: datos.number,
                                                            txtCTelCode: datos.code,
                                                            txtCTelPais: datos.iso,
                                                        },
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="ptipo"
                                                style={{ fontWeight: 600 }}
                                            >
                                                Tipo Asistente
                                            </label>
                                            <Select
                                                id="listCTiposAsistente"
                                                name="listCTiposAsistente"
                                                className="form-control form-control-md border border-dark"
                                                data-label="Tipo Asistente"
                                                placeholder="Seleccionar tipo asistente"
                                                datos={catalogos.catTipoAsistente}
                                                value={datosRegistro?.convencion.listCTiposAsistente}
                                                tipoValue={1}
                                                onChange={({ item }) => {
                                                    setSelects((s) => ({
                                                        ...s,
                                                        listCTiposAsistente: item
                                                    }))
                                                    setSelects((s) => ({
                                                        ...s,
                                                        listCTiposAsistente: item
                                                    }))
                                                }}
                                            />
                                        </div>
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pestacion_servicio"
                                            >
                                                {selects.listCTiposAsistente.clave === 1 ? 'Grupo Gasolinero' :
                                                    // selects.listCTiposAsistente.clave === 2 ? 'Empresa' :
                                                        selects.listCTiposAsistente.clave === 3 ? 'Empresa o Marca' :
                                                            selects.listCTiposAsistente.clave === 4 ? 'Institución' : 'Empresa'}
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                id="txtCEmpresa"
                                                name="txtCEmpresa"
                                                type="tel"
                                                defaultValue={datosRegistro?.convencion.txtCEmpresa}
                                                placeholder={`${selects.listCTiposAsistente.clave === 1 ? 'Grupo Gasolinero' :
                                                    selects.listCTiposAsistente.clave === 2 ? 'Empresa' :
                                                        selects.listCTiposAsistente.clave === 3 ? 'Empresa o Marca' :
                                                            selects.listCTiposAsistente.clave === 4 ? 'Institución' : 'Empresa'}`}
                                                onInput={(e) => {tools.limitChar(e, '', 100)}}
                                            />
                                        </div>
                                    </div> */}
                                    {/* { datosRegistro?.convencion.listCTiposAsistente === 1 ?
                                        selects.listCTiposAsistente.clave === 1 ? 
                                            <>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pgrupo_gasolinero"
                                                        >
                                                            Agregar número de permiso
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id="txtCPermiso"
                                                            name="txtCPermiso"
                                                            type="text"
                                                            placeholder="Número de permiso"
                                                            value={datosRegistro?.convencion.txtCPermiso}
                                                            onInput={(e) => {tools.limitChar(e, 0, 100)}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pgrupo_gasolinero"
                                                        >
                                                            Estación
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id="txtCEstacion"
                                                            name="txtCEstacion"
                                                            type="text"
                                                            placeholder="Estación"
                                                            value={datosRegistro?.convencion.txtCEstacion || selects.txtCEstacion || ''} // Ensure value is properly bound
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setSelects((s) => ({
                                                                    ...s,
                                                                    txtCEstacion: value, // Update state on input change
                                                                }));
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </>    
                                        : 
                                            <>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pgrupo_gasolinero"
                                                        >
                                                            Agregar número de permiso
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id="txtCPermiso"
                                                            name="txtCPermiso"
                                                            type="text"
                                                            placeholder="Número de permiso"
                                                            value={datosRegistro?.convencion.txtCPermiso}
                                                            onInput={(e) => {tools.limitChar(e, 0, 100)}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pgrupo_gasolinero"
                                                        >
                                                            Estación
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id="txtCEstacion"
                                                            name="txtCEstacion"
                                                            type="text"
                                                            placeholder="Estación"
                                                            value={datosRegistro?.convencion.txtCEstacion || selects.txtCEstacion || ''} // Ensure value is properly bound
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setSelects((s) => ({
                                                                    ...s,
                                                                    txtCEstacion: value, // Update state on input change
                                                                }));
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                    :
                                        selects.listCTiposAsistente.clave === 1 ? 
                                            <>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pgrupo_gasolinero"
                                                        >
                                                            Agregar número de permiso
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id="txtCPermiso"
                                                            name="txtCPermiso"
                                                            type="text"
                                                            placeholder="Número de permiso"
                                                            value={datosRegistro?.convencion.txtCPermiso}
                                                            onInput={(e) => {tools.limitChar(e, 0, 100)}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pgrupo_gasolinero"
                                                        >
                                                            Estación
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id="txtCEstacion"
                                                            name="txtCEstacion"
                                                            type="text"
                                                            placeholder="Estación"
                                                            value={datosRegistro?.convencion.txtCEstacion || selects.txtCEstacion || ''} // Ensure value is properly bound
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setSelects((s) => ({
                                                                    ...s,
                                                                    txtCEstacion: value, // Update state on input change
                                                                }));
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        : ''} */}
                                    {/* <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="pnacionalidad"
                                                style={{ fontWeight: 600 }}
                                            >
                                                Nacionalidad
                                            </label>
                                            <Select
                                                className="form-control form-control-md border border-dark"
                                                data-label="Estado"
                                                placeholder="Seleccionar nacionalidad"
                                                id="listCNacion"
                                                name="listCNacion"
                                                datos={[{clave: '', label: 'Seleccionar nacionalidad'}, ...catalogos.catNacionalidad]}
                                                value={datosRegistro?.convencion.nacionalidad_clave ? datosRegistro?.convencion.nacionalidad_clave : ''}
                                                onChange={({ item }) => {
                                                    setSelects((s) => ({
                                                        ...s,
                                                        listCNacion: item
                                                    }))
                                                }}
                                            />
                                        </div>
                                    </div> */}
                                    {/* Campos de Mexicanos */}
                                        <Fragment>
                                            <div className="col-md-4" hidden>
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="ppais"
                                                    >
                                                        País
                                                    </label>
                                                    <input
                                                    className="form-control border border-dark"
                                                    id="listCPais"
                                                    name="listCPais"
                                                    type="text"
                                                    defaultValue={datosRegistro?.convencion.nacionalidad_clave == false ? 'México' : ''}
                                                />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label
                                                        htmlFor="pestado"
                                                        style={{ fontWeight: 600 }}
                                                    >
                                                        Estado
                                                    </label>
                                                    <Select
                                                        className="form-control form-control-md border border-dark"
                                                        data-label="Estado"
                                                        placeholder="Seleccionar estado"
                                                        id="listCEstado"
                                                        name="listCEstado"
                                                        datos={catalogos.catEstados}
                                                        value={datosRegistro?.convencion.listCEstado}
                                                        tipoValue={1}
                                                        onChange={({ item }) => {
                                                            onSelectEstado(item, 1, 2)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label
                                                        htmlFor="pciudad"
                                                        style={{ fontWeight: 600 }}
                                                    >
                                                        Ciudad
                                                    </label>
                                                    <Select
                                                        className="form-control form-control-md border border-dark"
                                                        data-label="Estado"
                                                        placeholder="Seleccionar ciudad"
                                                        id="listCCiudad"
                                                        name="listCCiudad"
                                                        value={datosRegistro?.convencion.listCCiudad}
                                                        datos={ datosRegistro ? catalogos.catCiudad : selects.catCCiudad}
                                                        tipoValue={1}
                                                        onChange={({ item }) => {
                                                            setSelects((s) => ({
                                                                ...s,
                                                                listCCiudad: item
                                                            }))
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </Fragment>
                                        
                                    {/* Campos de Extranjeros */}
                                    {selects.listCNacion.clave == 2 || datosRegistro?.convencion.NACION == 2 ?
                                        <Fragment>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="pextranjero_pais"
                                                    >
                                                        País
                                                    </label>
                                                    <Select
                                                        className="form-control form-control-md border border-dark"
                                                        data-label="País"
                                                        placeholder="Seleccionar país"
                                                        id="listCPais"
                                                        name="listCPais"
                                                        datos={catalogos.catPaises}
                                                        value={datosRegistro?.convencion.PAIS}
                                                        onChange={({ item }) => {
                                                            setSelects((s) => ({
                                                                ...s,
                                                                listCPais: item
                                                            }))
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="pextranjero_estado"
                                                    >
                                                        Estado/provincia
                                                    </label>
                                                    <input
                                                        className="form-control border border-dark"
                                                        id="txtCEstado"
                                                        name="txtCEstado"
                                                        type="text"
                                                        placeholder="Estado/provincia"
                                                        value={datosRegistro?.convencion.ESTADO}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="pextranjero_ciudad"
                                                    >
                                                        Ciudad
                                                    </label>
                                                    <input
                                                        className="form-control border border-dark"
                                                        id="txtCCiudad"
                                                        name="txtCCiudad"
                                                        type="text"
                                                        placeholder="Ciudad"
                                                        value={datosRegistro?.convencion.CIUDAD}
                                                    />
                                                </div>
                                            </div>

                                        </Fragment>
                                        : ''}

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label style={{ fontWeight: 600 }}>¿Por qué medio se enteraron?
                                                </label>
                                                <Select
                                                    className="form-control form-control-md border border-dark"
                                                    data-label="Medio"
                                                    placeholder='Seleccione una opción'
                                                    id="listMedios"
                                                    name="listMedios"
                                                    value={datosRegistro?.convencion.listMedios}
                                                    tipoValue={1}
                                                    datos={[
                                                        { value: 'WhatsApp', label: 'WhatsApp', clave: 'WhatsApp' },
                                                        { value: 'Redes Sociales', label: 'Redes Sociales', clave: 'Redes Sociales' },   
                                                        { value: 'Correo electrónico', label: 'Correo electrónico', clave: 'Correo electrónico' },
                                                        { value: 'Influencer', label: 'Influencer', clave: 'Influencer' },
                                                        { value: 'Referencia (Amigo, Colega o Conocido)', label: 'Referencia (Amigo, Colega o Conocido)', clave: 'Referencia (Amigo, Colega o Conocido)' }
                                                    ]}
                                                    onChange={({ item }) => {
                                                        setSelects((s) => ({ 
                                                            ...s, 
                                                            listMedios: item, 
                                                            // txtAplicaDF: item.clave == 1 || item.clave == 2 || item.clave == 8,
                                                            // txtEsCortesia: item.clave == 1 || item.clave == 2? false: item.clave == 8
                                                        }))
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <label
                                                htmlFor="fcomentarios"
                                                style={{ fontWeight: 600 }}
                                            >
                                                Comentarios de contacto
                                            </label>
                                            <div className="form-group">
                                                <textarea
                                                    id="txtCComentarios"
                                                    name="txtCComentarios"
                                                    cols="30"
                                                    rows="5"
                                                    className="w-100 border border-dark"
                                                    defaultValue={datosRegistro?.convencion.txtCComentarios}
                                                    onInput={(e) => {tools.limitChar(e, 0, 250)}}
                                                ></textarea>
                                            </div>
                                        </div>

                                        <input id={`txtCTelPhone`} name="txtCTelPhone" value={formContacto?.data.txtCTel || datosRegistro?.convencion.txtCTel  || ''}  hidden/>
                                        <input id={`txtCTelCodPais`} name="txtCTelCodPais" value={formContacto?.data.txtCTelCode || datosRegistro?.convencion.txtCTelCode  || ''}  hidden/>
                                        <input id={`txtCTelISO`} name="txtCTelISO" value={formContacto?.data.txtCTelPais || datosRegistro?.convencion.txtCTelPais || ''}  hidden/>

                                        <input id={`txtCWhatssPhone`} name="txtCWhatssPhone" value={formContacto?.data.txtCWhatssApp || datosRegistro?.convencion.txtCWhatssApp  || ''}  hidden/>
                                        <input id={`txtCWhatssAppCodPais`} name="txtCWhatssAppCodPais" value={formContacto?.data.txtCWhatssAppCode || datosRegistro?.convencion.txtCWhatssAppCode  || ''}  hidden/>
                                        <input id={`txtCWhatssAppISO`} name="txtCWhatssAppISO" value={formContacto?.data.txtCWhatssAppPais || datosRegistro?.convencion.txtCWhatssAppPais || ''}  hidden/>

                                        {esEditar ? 
                                            <>
                                                <div className="col-md-8">
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <button type="button" id="btnEditar" className="btn btn-primary btn-lg btn-block" onClick={() => editarDatosContacto()}>Editar datos de contacto</button>
                                                </div>    
                                            </>
                                        : ''}
                                    
                                </form>
                                {/* : ''} */}
                                
                                {(selects.listTipoCarnet.clave === "1" || selects.listTipoCarnet.clave === "3") || (esEditar && (datosRegistro?.convencion?.tipo_carnet === 1 || datosRegistro?.convencion?.tipo_carnet === 3)) ?
                                    <Fragment>
                                                <div className="form-group">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input border-dark"
                                                            id={`txtAplicaDF`} 
                                                            name="txtAplicaDF"
                                                            type="checkbox"
                                                            placeholder="Datos fiscales"
                                                            checked={selects.txtAplicaDF? true: false}
                                                            value={selects.txtAplicaDF? 1: 0}
                                                            // disabled={selects.txtAplicaDF? true: false}
                                                            // {...(datos.txtEsAnfitrion? checked: '')}
                                                            onChange={(e) => {
                                                                e.persist()
                                                                setSelects((s) => ({
                                                                    ...s,
                                                                    txtAplicaDF: !s.txtAplicaDF
                                                                }))
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor="flexCheckDefault"  style={{ fontWeight: 600, paddingTop: '13px' }}>
                                                            Requiere factura
                                                        </label>
                                                        {/* <span className={`text-danger txtVaciosItem${indice + 1} txtEsAnfitrion${indice + 1}`} style={{display: 'none'}}>Falta completar Anfitrion</span>   */}
                                                    </div>
                                                </div>
                                            </Fragment> 
                                    : ''}

                                {selects.txtAplicaDF  ?
                                    <Fragment>
                                        <div className="row mb-4 carnet-select">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <form id="formDf" className="row form theme-form">
                                                        <div className="col-12">
                                                            <h5 className="mb-3 text-info">Datos Fiscales</h5>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="frazon_social"
                                                                >
                                                                    Razón Social<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFRs"
                                                                    name="txtFRs"
                                                                    type="text"
                                                                    placeholder="Razón Social"
                                                                    defaultValue={formDf.data.txtFRs}
                                                                    onInput={(e) => {tools.limitChar(e, 0, 100)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFRs" style={{ display: 'none' }}>Falta completar (Razón Social)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="frfc"
                                                                >
                                                                    RFC<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFRfc"
                                                                    name="txtFRfc"
                                                                    type="text"
                                                                    placeholder="RFC"
                                                                    defaultValue={formDf.data.txtFRfc}
                                                                    onInput={(e) => {tools.limitChar(e, 7, 13)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFRfc" style={{ display: 'none' }}>Falta completar (RFC)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fregimen_fiscal"
                                                                >
                                                                    Régimen Fiscal<span className="text-danger">*</span>
                                                                </label>
                                                                <Select
                                                                    className="form-control form-control-md border border-dark"
                                                                    data-label="Régimen Fiscal"
                                                                    placeholder="Seleccionar Régimen Fiscal"
                                                                    id="listFRegimenFiscal"
                                                                    name="listFRegimenFiscal"
                                                                    value={selects.listFRegimenFiscal.clave}
                                                                    datos={catalogos.catRegimenFiscal}
                                                                    onChange={({ item }) => {
                                                                        setSelects((s) => ({
                                                                            ...s,
                                                                            listFRegimenFiscal: item
                                                                        }))
                                                                    }}
                                                                />
                                                                <span className="text-danger txtVaciosDf listFRegimenFiscal" style={{ display: 'none' }}>Falta completar (Régimen Fiscal)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fmetodo_pago"
                                                                >
                                                                    Forma de pago<span className="text-danger">*</span>
                                                                </label>
                                                                <Select
                                                                    className="form-control form-control-md border border-dark"
                                                                    data-label="método de forma de pago"
                                                                    placeholder="Seleccionar forma de pago"
                                                                    id="listFFormaPago"
                                                                    name="listFFormaPago"
                                                                    value={selects.listFMetodoPago.clave}
                                                                    datos={catalogos.catFormaPago}
                                                                    onChange={({ item }) => {
                                                                        setSelects((s) => ({
                                                                            ...s,
                                                                            listFMetodoPago: item
                                                                        }))
                                                                    }}
                                                                />
                                                                <span className="text-danger txtVaciosDf listFFormaPago" style={{ display: 'none' }}>Falta completar (Forma de pago)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fcfdi"
                                                                >
                                                                    Uso CFDI<span className="text-danger">*</span>
                                                                </label>
                                                                <Select
                                                                    className="form-control form-control-md border border-dark"
                                                                    data-label="Estado"
                                                                    placeholder="Seleccionar Uso CFDI"
                                                                    id="listFUsoCfdi"
                                                                    name="listFUsoCfdi"
                                                                    value={selects.listFUsoCfdi.clave}
                                                                    datos={catalogos.catUsoCfdi}
                                                                    onChange={({ item }) => {
                                                                        setSelects((s) => ({
                                                                            ...s,
                                                                            listFUsoCfdi: item
                                                                        }))
                                                                    }}
                                                                />
                                                                <span className="text-danger txtVaciosDf listFUsoCfdi" style={{ display: 'none' }}>Falta completar (Uso CFDI)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fcalle"
                                                                >
                                                                    Calle<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFCalle"
                                                                    name="txtFCalle"
                                                                    type="text"
                                                                    placeholder="Calle"
                                                                    defaultValue={formDf.data.txtFCalle}
                                                                    onInput={(e) => {tools.limitChar(e, 0, 100)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFCalle" style={{ display: 'none' }}>Falta completar (Calle)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fcolonia"
                                                                >
                                                                    Colonia<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFColonia"
                                                                    name="txtFColonia"
                                                                    type="text"
                                                                    placeholder="Colonia"
                                                                    defaultValue={formDf.data.txtFColonia}
                                                                    onInput={(e) => {tools.limitChar(e, 0, 50)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFColonia" style={{ display: 'none' }}>Falta completar (Colonia)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fnumero_exterior"
                                                                >
                                                                    Núm. Exterior<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFNumExt"
                                                                    name="txtFNumExt"
                                                                    type="text"
                                                                    placeholder="Núm. Exterior"
                                                                    defaultValue={formDf.data.txtFNumExt}
                                                                    onInput={(e) => {tools.limitChar(e, '', 100)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFNumExt" style={{ display: 'none' }}>Falta completar (Núm. Exterior)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fnumero_interior"
                                                                >
                                                                    Núm. Interior
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFNumInt"
                                                                    name="txtFNumInt"
                                                                    type="text"
                                                                    placeholder="Núm. Interior"
                                                                    defaultValue={formDf.data.txtFNumInt}
                                                                    onInput={(e) => {tools.limitChar(e, '', 100)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFNumInt" style={{ display: 'none' }}>Falta completar (Núm. Interior)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fcodigo_postal"
                                                                >
                                                                    Código Postal<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFCp"
                                                                    name="txtFCp"
                                                                    type="text"
                                                                    placeholder="Código Postal"
                                                                    defaultValue={formDf.data.txtFCp}
                                                                    onInput={(e) => {tools.limitChar(e, 1, 5)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFCp" style={{ display: 'none' }}>Falta completar (Código Postal)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="festado"
                                                                >
                                                                    Estado<span className="text-danger">*</span>
                                                                </label>
                                                                <Select
                                                                    className="form-control form-control-md border border-dark"
                                                                    data-label="Estado"
                                                                    placeholder="Seleccionar estado"
                                                                    id="listFEstado"
                                                                    name="listFEstado"
                                                                    value={selects.listFEstado.clave}
                                                                    datos={catalogos.catEstados}
                                                                    onChange={({ item }) => {
                                                                        onSelectEstado(item, 2)
                                                                    }}
                                                                />
                                                                <span className="text-danger txtVaciosDf listFEstado" style={{ display: 'none' }}>Falta completar (Estado)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fciudad"
                                                                >
                                                                    Ciudad<span className="text-danger">*</span>
                                                                </label>
                                                                <Select
                                                                    className="form-control form-control-md border border-dark"
                                                                    data-label="Estado"
                                                                    placeholder="Seleccionar ciudad"
                                                                    id="listFCiudad"
                                                                    name="listFCiudad"
                                                                    value={selects.listFCiudad.clave}
                                                                    datos={selects.catFCiudad}
                                                                    onChange={({ item }) => {
                                                                        setSelects((s) => ({
                                                                            ...s,
                                                                            listFCiudad: item
                                                                        }))
                                                                    }}
                                                                />
                                                                <span className="text-danger txtVaciosDf listFCiudad" style={{ display: 'none' }}>Falta completar (Ciudad)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="fcorreo"
                                                                >
                                                                    Correo Electrónico<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    id="txtFCorreo"
                                                                    name="txtFCorreo"
                                                                    type="text"
                                                                    placeholder="Correo Electrónico"
                                                                    defaultValue={formDf.data.txtFCorreo}
                                                                    onInput={(e) => {tools.limitChar(e, 2, 80)}}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFCorreo" style={{ display: 'none' }}>Falta completar (Correo Electrónico)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="ftelefono"
                                                                >
                                                                    Teléfono<span className="text-danger">*</span>
                                                                </label>
                                                                <br></br>
                                                                <PhoneInput
                                                                    id='txtFWhatsapp'
                                                                    className={'border border-dark'}
                                                                    value={formDf.data.txtFWhatsapp}
                                                                    code={formDf.data.txtFWhatsappCode}
                                                                    iso={formDf.data.txtFWhatsappPais}
                                                                    label='Whatsapp'
                                                                    onChange={(datos) => {
                                                                        setFormFf((s) => ({
                                                                            ...s,
                                                                            data: {
                                                                                ...s.data,
                                                                                txtFWhatsapp: datos.number,
                                                                                txtFWhatsappCode: datos.code,
                                                                                txtFWhatsappPais: datos.iso,
                                                                            },
                                                                        }));
                                                                    }}
                                                                />
                                                                <span className="text-danger txtVaciosDf txtFWhatsapp" style={{ display: 'none' }}>Falta completar (Teléfono)</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label
                                                                htmlFor="fcomentarios"
                                                                style={{ fontWeight: 600 }}
                                                            >
                                                                Comentarios de datos fiscales
                                                            </label>
                                                            <div className="form-group">
                                                                <textarea
                                                                    id="txtFComentarios"
                                                                    name="txtFComentarios"
                                                                    cols="30"
                                                                    rows="5"
                                                                    className="w-100 border border-dark"
                                                                    defaultValue={formDf.data.txtFComentarios}
                                                                    onInput={(e) => {tools.limitChar(e, 0, 250)}}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                        {esEditar?<div className="col-md-12">
                                                            <div className="row d-flex justify-content-end">
                                                                <div className="col-md-4">
                                                                    <button type="button" className="btn btn-primary btn-lg btn-block"
                                                                        onClick={() => onClickEditarFactura()}
                                                                    >Guardar Datos Facturación</button>
                                                                </div>
                                                            </div>
                                                        </div>: ''}
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                : ''}

                                    <Fragment>
                                    <div className="form-group">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input border-dark"
                                                id={`txtEsCortesia`} 
                                                name="txtEsCortesia"
                                                type="checkbox"
                                                placeholder="Es Cortesia"
                                                checked={selects.txtEsCortesia? true: false}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setSelects((s) => ({
                                                        ...s,
                                                        txtEsCortesia: !s.txtEsCortesia
                                                    }))
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="flexCheckDefault"  style={{ fontWeight: 600, paddingTop: '13px' }}>
                                                Es cortesía
                                            </label>
                                            {/* <span className={`text-danger txtVaciosItem${indice + 1} txtEsAnfitrion${indice + 1}`} style={{display: 'none'}}>Falta completar Anfitrion</span>   */}
                                        </div>
                                    </div>
                                    <div className="row mb-4 carnet-select">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label style={{ fontWeight: 600 }} htmlFor="fmetodo_pago">
                                                        Número de carnets<span className="text-danger">*</span>
                                                </label>
                                                <Select
                                                    disabled={esEditar && parseInt(idRegistro) !== 11109}
                                                    className="form-control border border-dark"
                                                    placeholder="Número de carnets"
                                                    id={`txtNumeroCarnets`} 
                                                    name="txtNumeroCarnets"
                                                    value={datosRegistro?.asistentes.length ? datosRegistro?.asistentes.length : selects.selectedNumCarnets}
                                                    datos={[
                                                        { value: '1', label: '1', clave: '1' },
                                                        { value: '2', label: '2', clave: '2' },
                                                        { value: '3', label: '3', clave: '3' },
                                                        { value: '4', label: '4', clave: '4' },
                                                        { value: '5', label: '5', clave: '5' },
                                                        { value: '6', label: '6', clave: '6' },
                                                        { value: '7', label: '7', clave: '7' },
                                                        { value: '8', label: '8', clave: '8' },
                                                        { value: '9', label: '9', clave: '9' },
                                                        { value: '10', label: '10', clave: '10' },
                                                    ]}
                                                    onChange={(e) => {
                                                        console.log('🔍 Debug - idRegistro:', idRegistro, 'tipo:', typeof idRegistro, 'parseInt:', parseInt(idRegistro), 'esEditar:', esEditar, 'Permitir edición:', esEditar && parseInt(idRegistro) === 11109);
                                                        let value = e.item.clave
                                                        let num = Number(value)
                                                        setSelects((v) => ({...v, selectedNumCarnets: value}))
                                                        if(num){
                                                            onClickNuevoCarnet(num)
                                                        }
                                                    }}
                                                />
                                                <span className="text-danger txtVaciosDf txtNumeroCarnets" style={{ display: 'none' }}>Falta completar (Número de carnets)</span>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="fmetodo_pago"
                                                >
                                                    Número de carnets<span className="text-danger">*</span>
                                                </label>

                                                <input
                                                    className="form-control border border-dark"
                                                    id={`txtNumeroCarnets`} 
                                                    name="txtNumeroCarnets"
                                                    type="number"
                                                    placeholder="Número de carnets"
                                                    value={datosRegistro?.asistentes.length ? datosRegistro?.asistentes.length : 1}
                                                    disabled={esEditar && parseInt(idRegistro) !== 11109}
                                                    onChange={(e) => {
                                                        e.persist()
                                                        let num = Number(e.target.value)
                                                        setSelects((v) => ({...v, selectedNumCarnets: e.target.value}))
                                                        if(num){
                                                            onClickNuevoCarnet(num)
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        let num = Number(e.target.value)
                                                        if(!num){
                                                            setSelects((v) => ({...v, selectedNumCarnets: carnets.length}))
                                                        }
                                                    }}
                                                />
                                                <span className="text-danger txtVaciosDf txtNumeroCarnets" style={{ display: 'none' }}>Falta completar (Número de carnets)</span>
                                            </div>
                                        </div> */}
                                        {/* <div className="col-md-6">
                                        </div> */}
                                        {/* <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="fmetodo_pago"
                                                >
                                                    Carnets individuales: <span className="text-danger">{datosEvento.numCarnetInd}</span>
                                                </label><br/>
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="fmetodo_pago"
                                                >
                                                    Carnets dobles: <span className="text-danger">{datosEvento.numCarnetDoble}</span>
                                                </label><br/>
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="fmetodo_pago"
                                                >
                                                    Total de asistentes: <span className="text-danger">{datosEvento.totalAsistentes}</span>
                                                </label>
                                            </div>
                                        </div> */}
                                    </div>
                                    </Fragment>
                                    <div className="row">
                                        <div className="col-12 p-0">
                                            <h5 className="mb-3 text-info">Lista de accesos</h5>
                                        </div>
                                        <div className="col-12 p-0">
                                            {esEditar ? 
                                                <>
                                                    {datosRegistro?.asistentes.map((carnet, i) => (
                                                            <ItemCarnet
                                                                key={'item'+i}
                                                                indice={i}
                                                                onClickEliminarCarnet={onClickEliminarCarnet}
                                                                catalogos={catalogos}
                                                                carnet={carnet}
                                                                listTipoCarnet={selects.listTipoCarnet}
                                                                carnets={datosRegistro?.asistentes}
                                                                datosEvento={datosEvento}
                                                                setDatosEvento={setDatosEvento}
                                                                esEditar={esEditar}
                                                                parentIsStudent={parentIsStudentGlobal}
                                                                onClickEditarCarnet={onClickEditarCarnet}
                                                            
                                                            />
                                                        ))} 
                                                </>
                                            : 
                                                <>
                                                    {carnets.map((carnet, i) => (
                                                        <ItemCarnet
                                                            key={'item'+i}
                                                            indice={i}
                                                            onClickEliminarCarnet={onClickEliminarCarnet}
                                                            catalogos={catalogos}
                                                            carnet={carnet}
                                                            listTipoCarnet={selects.listTipoCarnet}
                                                            carnets={datosRegistro?.carnets}
                                                            datosEvento={datosEvento}
                                                            setDatosEvento={setDatosEvento}
                                                            esEditar={esEditar}
                                                            parentIsStudent={parentIsStudentGlobal}
                                                            onClickEditarCarnet={onClickEditarCarnet}
                                                        />
                                                    ))} 
                                                </>
                                            }

                                        </div>
                                    </div>
                                    {!esEditar?
                                        <div className="row">
                                            <div className="col-md-12 d-flex justify-content-center">
                                                {/* <div className="d-flex justify-content-center"> */}
                                                <button type="button" style={{ width: '10%' }} className="btn btn-primary btn-lg btn-block mb-4"
                                                    onClick={() => { 
                                                        setSelects((v) => ({...v, selectedNumCarnets: carnets.length + 1}))
                                                        onClickNuevoCarnet(1, 2)
                                                    }}
                                                >
                                                    <i className="fa fa-plus-square" aria-hidden="true"></i>
                                                </button>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    : esEditar && (datosRegistro?.convencion?.tipo_carnet != 1 || parseInt(idRegistro) === 11109) ? 
                                        <div className="row">
                                            <div className="col-md-12 d-flex justify-content-center">
                                                <button type="button" style={{ width: '20%' }} className="btn btn-primary btn-lg btn-block mb-4"
                                                    onClick={() => { 
                                                        console.log('Nuevo Carnet - idRegistro:', idRegistro, 'tipo carnet:', datosRegistro?.convencion?.tipo_carnet);
                                                        setModal((s) => ({
                                                            estado: 1,
                                                            datos: {catalogos, idRegistro}
                                                        }))
                                                    }}
                                                >
                                                    Nuevo Carnet
                                                </button>
                                            </div>
                                        </div>
                                    :''}
                                    {!esEditar?
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button 
                                                    id="btnEnviar"
                                                    type="button" 
                                                    style={{width: '100%'}} 
                                                    className="btn btn-primary btn-lg btn-block mb-4"
                                                    disabled={estatusRegistrar}
                                                    onClick={() => onClickEnviar()}
                                                >Enviar</button>
                                            </div>
                                        </div>
                                    :''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            {modal.estado?
            <ModalCarnetNuevo 
                modal={modal}
                setModal={setModal}
                setRefresh={setRefresh}
                selects={selects}
            />:''}
            
            {/* Debug: Mostrar idRegistro en pantalla */}
            {/* <div style={{ 
                position: 'fixed', 
                bottom: '10px', 
                right: '10px', 
                backgroundColor: 'rgba(0,0,0,0.8)', 
                color: 'white', 
                padding: '10px', 
                borderRadius: '5px',
                zIndex: 9999,
                fontSize: '12px',
                fontFamily: 'monospace'
            }}>
                <div>idRegistro: {JSON.stringify(idRegistro)} (tipo: {typeof idRegistro})</div>
                <div>parseInt: {parseInt(idRegistro)}</div>
                <div>esEditar: {esEditar ? 'true' : 'false'}</div>
                <div>Permite editar: {esEditar && parseInt(idRegistro) === 11109 ? 'SÍ' : 'NO'}</div>
            </div> */}
        </div>
    );
};

export default Default;
